import React, { useState, useEffect } from 'react';
import styles from '../static/styles/DailyGamingTasks.module.css';
import weeklyTournamentStyles from '../static/styles/WeeklyTournaments.module.css';
import calendarIcon from '../static/img/Home/calendarIcon.svg';
import { fetchDailyGames, listEslGames } from '../api/games';
import gamesListRaw from '../static/data/games.json';

import pubgIcon from '../static/img/DailyGamingTasks/iconPubgDailyTasks.png';
import pubgImage from '../static/img/DailyGamingTasks/imagePubgDaily.avif';
import apexIcon from '../static/img/DailyGamingTasks/iconApexDailyTasks.avif';
import apexImage from '../static/img/DailyGamingTasks/imageApexDaily.avif';
import codIcon from '../static/img/DailyGamingTasks/iconCODDailyTasks.avif';
import codImage from '../static/img/DailyGamingTasks/iamgeCODDaily.avif';
import minecraftIcon from '../static/img/DailyGamingTasks/iconMinecraftDailyTasks.avif';
import minecraftImage from '../static/img/DailyGamingTasks/imageMinecraftDaily.avif';
import clashOfClansIcon from '../static/img/DailyGamingTasks/iconCOCDailyTasks.avif';
import clashOfClansImage from '../static/img/DailyGamingTasks/imageCOCDaily.avif';
import clashRoyaleIcon from '../static/img/DailyGamingTasks/iconCRDailyTasks.avif';
import clashRoyaleImage from '../static/img/DailyGamingTasks/imageCRDaily.avif';
import fortniteIcon from '../static/img/DailyGamingTasks/iconFortniteDailyTasks.avif';
import fortniteImage from '../static/img/DailyGamingTasks/imageFortniteDaily.avif';
import amongUsIcon from '../static/img/DailyGamingTasks/iconAmongUsDailyTasks.avif';
import amongUsImage from '../static/img/DailyGamingTasks/imageSusDaily.avif';
import subwaySurfersIcon from '../static/img/DailyGamingTasks/iconSubSurfDailyTasks.avif';
import subwaySurfersImage from '../static/img/DailyGamingTasks/imageSubSurfDaily.avif';
import valorantIcon from '../static/img/DailyGamingTasks/iconValorantDailyTasks.avif';
import valorantImage from '../static/img/DailyGamingTasks/imageValorantDaily.avif';
import freeFireIcon from '../static/img/DailyGamingTasks/iconFreeFireDailyTasks.avif';
import freeFireImage from '../static/img/DailyGamingTasks/imageFreeFireDaily.avif';
import robloxIcon from '../static/img/DailyGamingTasks/iconRobloxDailyTasks.avif';
import robloxImage from '../static/img/DailyGamingTasks/imageRobloxDaily.avif';
import fifaIcon from '../static/img/DailyGamingTasks/iconFifaDailyTasks.avif';
import fifaImage from '../static/img/DailyGamingTasks/imageFifaGaming.avif';
import eightBallPoolImage from '../static/img/DailyGamingTasks/image8BallDaily.avif';
import eightBallPoolIcon from '../static/img/DailyGamingTasks/icon8BallPool.avif';
import aimTrainCover from '../static/img/MadeByESL/coverAimTrain.avif';
import cannonClashCover from '../static/img/MadeByESL/coverCannonClash.avif';
import puzzleManiaCover from '../static/img/MadeByESL/coverPuzzleMania.avif';
import spaceFootballCover from '../static/img/MadeByESL/coverSpaceFootball.png.avif';
import CannonClashInstructions from '../components/CannonClashInstructions';

import { useNavigate } from 'react-router-dom';


// TODO: Centralize these funcs
const getGameIcon = (gameName) => {
    switch (gameName.toLowerCase()) {
        case 'pubg mobile': return pubgIcon;
        case 'apex legends': return apexIcon;
        case 'call of duty': return codIcon;
        case 'minecraft': return minecraftIcon;
        case 'clash of clans': return clashOfClansIcon;
        case 'clash royale': return clashRoyaleIcon;
        case 'fortnite': return fortniteIcon;
        case 'among us': return amongUsIcon;
        case 'subway surfers': return subwaySurfersIcon;
        case 'valorant': return valorantIcon;
        case 'freefire': return freeFireIcon;
        case 'roblox': return robloxIcon;
        case 'fifa mobile': return fifaIcon;
        case '8 ball pool': return eightBallPoolIcon;
        case 'puzzle mania': return puzzleManiaCover;

        default: return null;
    }
};

const getGameImage = (gameName) => {
    switch (gameName.toLowerCase()) {
        case 'pubg mobile': return pubgImage;
        case 'apex legends': return apexImage;
        case 'call of duty': return codImage;
        case 'minecraft': return minecraftImage;
        case 'clash of clans': return clashOfClansImage;
        case 'clash royale': return clashRoyaleImage;
        case 'fortnite': return fortniteImage;
        case 'among us': return amongUsImage;
        case 'subway surfers': return subwaySurfersImage;
        case 'valorant': return valorantImage;
        case 'freefire': return freeFireImage;
        case 'roblox': return robloxImage;
        case 'fifa mobile': return fifaImage;
        case '8 ball pool': return eightBallPoolImage;
        case 'aim train': return aimTrainCover;
        case 'cannon clash': return cannonClashCover;
        case 'puzzle mania': return puzzleManiaCover;
        case 'space football': return spaceFootballCover;
        default: return null;
    }
};

const DailyGamingTasks = () => {
    const [games, setGames] = useState([]);
    const [eslGames, setEslGames] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showInstructions, setShowInstructions] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        document.title = "Gaming Tasks | Ufone ESG"
        const loadGames = async () => {
            try {
                setLoading(true);
                setError(null);

                let gamesList = [];
                if (Array.isArray(gamesListRaw)) {
                    gamesList = gamesListRaw;
                } else if (typeof gamesListRaw === 'object' && gamesListRaw !== null) {
                    gamesList = gamesListRaw.default || [];
                }

                const [dailyGamesData, eslGamesResp] = await Promise.all([
                    fetchDailyGames(),
                    listEslGames()
                ]);
                setGames(dailyGamesData);

                let eslGamesArr = [];
                if (
                    eslGamesResp &&
                    eslGamesResp.success &&
                    eslGamesResp.data &&
                    Array.isArray(eslGamesResp.data.eslgames)
                ) {
                    eslGamesArr = eslGamesResp.data.eslgames
                        .map(eslGame => {
                            const match = gamesList.find(g =>
                                String(g.game_unique_id).toLowerCase() === String(eslGame.game_unique_id).toLowerCase()
                            );
                            if (match) {
                                return {
                                    ...match,
                                    ...eslGame
                                };
                            } else {
                                return {
                                    ...eslGame,
                                    game: eslGame.game_name
                                };
                            }
                        })
                        .filter(Boolean);
                } else {
                    // Fallback to static data if API fails
                    eslGamesArr = gamesList.map(game => ({
                        ...game,
                        game: game.game_name
                    }));
                }

                setEslGames(eslGamesArr);
            } catch (err) {
                setError(err.message || 'Failed to load daily games');
            } finally {
                setLoading(false);
            }
        };

        loadGames();
    }, []);

    if (loading) {
        return <div className={styles.loading}>Loading daily games...</div>;
    }

    if (error) {
        return <div className={styles.error}>{error}</div>;
    }

    const handleDailyGameClick = (gameId) => {
        if (!gameId) {
            return;
        }
        
        if (gameId === 'cannon_clash_001') {
            navigate('/tournaments');
            return;
        }
        
        navigate(`/game-challenges?gameId=${encodeURIComponent(gameId)}`);
    };

    const handleInstructionsClose = () => {
        setShowInstructions(false);
    };

    const handleShowInstructions = (gameName) => {
        const isCannonClash = gameName && gameName.toLowerCase().includes('cannon');
        if (isCannonClash) {
            setShowInstructions(true);
        }
    };

    return (
        <div className={styles.container}>
            <h2 className={styles.heading}>Gaming Challenges</h2>
            <p className={styles.subheading}>Play daily tasks & win extra credits</p>

            {eslGames.length > 0 && (
                <div className={styles.eslSection}>
                    <div className={styles.sectionSeparator}>
                        <span className={styles.sectionSeparatorText}>Made by ESG</span>
                    </div>                    <div className={styles.cardGrid}>
                        {eslGames
                            .filter((game) => game.game_status === 1)
                            .map((game) => {
                                const gameImage = getGameImage(game.game_name);
                                return (
                                    <div key={game.game_unique_id} className={styles.card}>
                                        <div
                                            onClick={() => handleDailyGameClick(game.gameId || game.game_unique_id)}
                                            className={styles.imageWrapper}
                                            style={{ backgroundImage: `url(${gameImage})` }}
                                        >
                                            <div className={styles.gameTagWrapper}></div>
                                            {game.game_name && game.game_name.toLowerCase().includes('cannon') && (
                                                <button 
                                                    className={weeklyTournamentStyles.infoButton}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleShowInstructions(game.game_name);
                                                    }}
                                                    title="View Game Instructions"
                                                >
                                                    <span className={weeklyTournamentStyles.infoIcon}>?</span>
                                                    <span className={weeklyTournamentStyles.infoText}>How to Play</span>
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}

                    </div>
                </div>
            )}

            {eslGames.length > 0 && games.length > 0 && (
                <div className={styles.sectionSeparator}>
                    <span className={styles.sectionSeparatorText}>Other Games</span>
                </div>
            )}

            <div className={styles.cardGrid}>
                {games.map((game) => {
                    const gameIcon = getGameIcon(game.game);
                    const gameImage = getGameImage(game.game);

                    return (
                        <div key={game.id} className={styles.card}>
                            <div
                                onClick={() => { handleDailyGameClick(game.gameId) }}
                                className={styles.imageWrapper}
                                style={{ backgroundImage: `url(${gameImage})` }}
                            >
                                <div className={styles.gameTagWrapper}>
                                    <div className={styles.gameTag}>
                                        <img src={gameIcon} alt={game.game} className={styles.gameIcon} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
            
            <CannonClashInstructions
                isOpen={showInstructions}
                onClose={handleInstructionsClose}
            />
        </div>
    );
};

export default DailyGamingTasks;